<template>
    <div>
        <el-page-header @back="goBack" content="广告数据报表"></el-page-header>
        <el-card class="form-container" style="margin-top: 25px" shadow="never">
            <el-form :inline="true" :model="queryData" size="small" label-width="120px">
                <el-form-item label="版本：">
                    <el-select v-model="queryData.version" multiple filterable @change="checkParam1($event)" placeholder="请选择/输入">
                        <el-option
                                v-for="item in versionList"
                                :key="item.versionCode"
                                :label="item.versionName"
                                :value="item.versionCode"
                                :disabled="item.disabled">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="游戏名称：">
                    <el-select v-model="queryData.gameIds" multiple  filterable placeholder="请选择/输入">
                        <el-option
                                v-for="item in gameList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="日期：">
                    <el-date-picker
                            v-model="queryData.timeDate"
                            type="daterange"
                            :clearable="false"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd">
                    </el-date-picker>&emsp;&emsp;
                </el-form-item>
                <el-form-item label="用户类型：">
                    <el-select v-model="queryData.user"   clearable placeholder="请选择" >
                        <el-option v-for="item in users" :label="item.name" :key="item.id" :value="item.id" ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="广告场景：">
                    <el-select v-model="queryData.scene"   clearable placeholder="请选择" >
                        <el-option v-for="item in scenes" :label="item.name" :key="item.id" :value="item.id" ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="渠道：">
                    <el-select v-model="queryData.channelId"  @change="selectGoodsByChannelId($event)" clearable placeholder="请选择">
                        <el-option value="0" label="全部"></el-option>
                        <el-option v-for="item in channelList" :label="item.name" :key="item.id" :value="item.id"></el-option>
                    </el-select>
                    <el-select v-model="queryData.subChannelId"   clearable placeholder="请选择" multiple filterable @change="checkParam($event)">
                        <el-option value="0" label="全部"></el-option>
                        <el-option v-for="item in subChannelList" :label="item.name" :key="item.id" :value="item.subChannel" :disabled="item.disabled"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="">
                    <el-button class="sub-sub8" type="primary" @click="query">查询</el-button>
                    <el-button class="sub-sub8" type="primary"  @click="exportExcel">导出</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <h1>
            <el-table
                border
                :data="adReportList"
                :header-cell-style="{background:'#282828'}"
                ref="filterTable"
                max-height="820"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"
                v-loading="loading">
            <el-table-column  prop="dt" label="日期" align="center"></el-table-column>
            <el-table-column  prop="gameName"   label="游戏名称" align="center"></el-table-column>
            <el-table-column  prop="versionName"   label="版本名" align="center"></el-table-column>
            <el-table-column  prop="subChannelName"   label="渠道名" align="center"></el-table-column>
            <el-table-column  prop="n_user" label="新增" align="center" ></el-table-column>
            <el-table-column  prop="a_user" label="活跃" align="center" ></el-table-column>
            <el-table-column  prop="watch_user" label="看广告用户数" align="center"></el-table-column>
            <el-table-column   label="广告渗透率" align="center"  >
                <template slot-scope="scope">
                    {{ scope.row.adJoinRate ===0 ? '0.00%' : (scope.row.adJoinRate * 100).toFixed(2) + '%' }}
                </template>
            </el-table-column>
            <el-table-column   label="广告流量填充率" align="center">
                <template slot-scope="scope">
                    {{ scope.row.adStreamRate ===0 ? '0.00%' : (scope.row.adStreamRate * 100).toFixed(2) + '%' }}
                </template>
            </el-table-column>
            <el-table-column label="总广告请求数" align="center" prop="req_num"></el-table-column>
            <el-table-column label="总广高展示数" align="center" prop="watch_num"></el-table-column>
            <el-table-column   label="人均流量请求次数" align="center">
                <template slot-scope="scope">
                    {{ scope.row.perAdRequest.toFixed(2)}}
                </template>
            </el-table-column>
            <el-table-column   label="人均广告展示次数"  align="center" >
                <template slot-scope="scope">
                    {{ scope.row.perAdWatch.toFixed(2)}}
                </template>
            </el-table-column>
            </el-table>
        </h1>
        <div>
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page.page"
                    :page-sizes="[20,50,100]"
                    :page-size="page.size"
                    layout="total, sizes, prev, pager, next"
                    :total="page.totalElements">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {
        channelList,
        downloadData,
        gameRunningList,
        copyList,
        searchAdReport
    } from "@/http/api";
    import utils from '@/utils'
    export default {
        name: "AdReport",
        data(){
            return{
                queryData:{
                    version:[],
                    gameIds:[-1],
                    timeDate:['',''],
                    user:0,
                    scene:0,
                    channelId:'',
                    subChannelId:[]
                },
                users:[{id:0,name:'全部'},
                    {id:1,name:'新用户'},
                    {id:2,name:'老用户'}],
                scenes:[{id:0,name:'全部'},
                    {id:1,name:'游戏内视频'},
                    {id:2,name:'新插屏半屏'}],
                page: {
                    size: 20,
                    page: 1,
                    totalElements: null
                },
                versionList:[],
                gameList:[],
                adReportList:[],
                channelList:[],
                subChannelList:[],
                loading:true,
                watchTag:'',
            }
        },
        methods:{
            selectGoodsByChannelId(val){
                this.watchTag = val;
                if(val !== null && val !== '' && val !== undefined && val !=='0') {
                    this.subChannelList = this.channelList.filter(channel => channel.id === val )[0].children.filter(subChannel=>subChannel.state===1);
                }
                if (val==='0'){
                    this.subChannelList=[];
                }
            },
            checkParam(val){
                let _this = this;
                if (val.indexOf('0') > -1){
                    this.subChannelList.forEach(function (subChannel) {
                        _this.$set(subChannel,'disabled',true);
                        _this.queryData.subChannelId=['0']
                    });
                }else {
                    this.subChannelList.forEach(function (subChannel) {
                        _this.$set(subChannel,'disabled',false);
                    });
                }

            },
            exportExcel() {
                if (this.queryData.version.length===1 && this.queryData.version[0]===''){
                    this.queryData.version=[];
                }
                let fileName = new Date().toLocaleString() + '广告数据报表.xlsx';
                downloadData(
                    '/ad/exportReportExcel',
                    Object.assign(this.queryData),
                    fileName
                )
            },
            checkParam1(val){
                let _this = this;
                if (val.indexOf('') > -1){
                    this.versionList.forEach(function (version) {
                        _this.$set(version,'disabled',true);
                        _this.queryData.version=['']
                    });
                }else {
                    this.versionList.forEach(function (version) {
                        _this.$set(version,'disabled',false);
                    });
                }
            },
            goBack(){
                this.$router.push({path: '/dataReport'})
            },
            handleSizeChange(size) {
                this.page.size = size;
                this.query();
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.query();
            },
            query(){
                this.loading = true;
                this.queryData.page = this.page.page;
                this.queryData.size = this.page.size;
                if (this.queryData.timeDate === null) {
                    this.queryData.timeDate = ['',''];
                }
                this.queryData.startTime = this.queryData.timeDate[0] ===''?null:this.queryData.timeDate[0];
                this.queryData.endTime = this.queryData.timeDate[1]===''?null:this.queryData.timeDate[1];
                //谜之操作，其实可以后端修改参数条件，打包太费劲，前端改了
                if (this.queryData.version.length===1 && this.queryData.version[0]===''){
                    this.queryData.version=[];
                }
                searchAdReport(this.queryData).then(resp=>{
                    //谜之操作，其实可以后端修改参数条件，打包太费劲，前端改了
                    if(this.queryData.version.length===0){
                        this.queryData.version=[''];
                    }
                    if (resp.data.status===0){
                        this.loading = false;
                        this.adReportList=resp.data.info.list;
                        this.page.totalElements =resp.data.info.totalElements;
                    }
                });
            }

        },
        watch:{
            watchTag(){
                this.queryData.subChannelId=[];
            }
        },
        created() {
            this.queryData.timeDate=[utils.TodayUtil.getToday(),utils.TodayUtil.getToday()];
            channelList().then(resp=>{
                this.channelList=resp.data.info;
            });
            gameRunningList().then(resp=>{
                this.gameList=resp.data.info;
                this.gameList.unshift({id:-1,name:'游戏中心'});
            });
            copyList().then(resp=>{
                this.versionList=resp.data.info;
                this.versionList.unshift({versionCode:'',versionName:'全部'});
            });
            this.query();
        }
    }
</script>

<style scoped>
    .sub-sub8{ position: relative; left: 110px}

</style>